import React from "react";

export const DoubleLine = ({ title, text,
                               fontColor='var(--font-color-1)',
                               maxLength = 40,
                               noGap=false,
                                 wrapText=true,
                                textWeight='300'
}) => {
    // Utility function to truncate text based on maxLength
    let truncateText = (_text) => {
        // Check if text needs to be truncated
        if (_text?.length > maxLength) {
            return `${_text?.substring?.(0, maxLength)}..`; // Truncate and append ellipsis
        }
        return _text; // Return original text if no truncation is needed
    };
    const titleStyle = {
        fontWeight: '500',
        color: fontColor

    }
    const textStyle = {
        color: fontColor,
        whiteSpace: wrapText ? 'normal' : 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

    }
    let containerStyle = {
        display: 'flex',
        flexDirection: 'column'
    }
    if (noGap){
        containerStyle.lineHeight = '1';
    }
    return (
        <div style={containerStyle}>
            <span style={titleStyle}>{truncateText(title)}</span>
            <span style={textStyle}>{truncateText(text)}</span>
        </div>
    );
}
